"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDays = exports.generateDefaultStopText = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _differenceInDays = _interopRequireDefault(require("date-fns/differenceInDays"));
var _Text = _interopRequireDefault(require("../Text"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant = require("./constant");
var _stopover = _interopRequireDefault(require("./stopover.proptypes"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var StyledStopoverContainer = _styledComponents.default.div.withConfig({
  displayName: "Stopover__StyledStopoverContainer",
  componentId: "sc-c9bqkz-0"
})(["display:flex;flex-direction:column;justify-content:center;width:", "px;"], function (_ref) {
  var size = _ref.size;
  return size;
});
var StyledStopoverSVG = _styledComponents.default.svg.withConfig({
  displayName: "Stopover__StyledStopoverSVG",
  componentId: "sc-c9bqkz-1"
})(["path,circle,rect{stroke:", ";}circle,rect{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyMedium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyMedium;
});
var convertUtcToGmt = function convertUtcToGmt(utcDate) {
  var dateObj = new Date(utcDate);
  var gmtDate = new Date(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate(), dateObj.getUTCHours(), dateObj.getUTCMinutes(), dateObj.getUTCSeconds(), dateObj.getUTCMilliseconds());
  return gmtDate;
};
var convertSecToHr = function convertSecToHr(seconds) {
  var hrs = seconds / 3600;
  var hour = Math.floor(hrs);
  var minute = Math.round((hrs - hour) * 60);
  return {
    hour: hour,
    minute: minute
  };
};
var getDurationFromSegments = function getDurationFromSegments(segment) {
  var totalDuration = 0;
  segment.map(function (seg) {
    totalDuration += seg.duration;
    totalDuration += seg.layoverTime ? seg.layoverTime : 0;
    return totalDuration;
  });
  return totalDuration;
};
var getDays = function getDays(from, to) {
  var day = (0, _differenceInDays.default)(new Date(to), new Date(from));
  return {
    day: day
  };
};
exports.getDays = getDays;
var generateDefaultStopText = function generateDefaultStopText(stops, translation) {
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  if (stops === 1) {
    return language.singleStop;
  }
  if (stops >= 2) {
    return language.multiStop.replace("{stop}", stops);
  }
  return language.nonStop;
};
exports.generateDefaultStopText = generateDefaultStopText;
var Stopover = function Stopover(_ref4) {
  var size = _ref4.size,
    designator = _ref4.designator,
    segments = _ref4.segments,
    showText = _ref4.showText,
    accessible = _ref4.accessible,
    theme = _ref4.theme,
    customProperties = _ref4.customProperties,
    translation = _ref4.translation;
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var segmentsLength = segments.length - 1;
  var _convertSecToHr = convertSecToHr(getDurationFromSegments(segments)),
    hour = _convertSecToHr.hour,
    minute = _convertSecToHr.minute;
  var _getDays = getDays(convertUtcToGmt(designator.departureTime), convertUtcToGmt(designator.arrivalTime)),
    day = _getDays.day;
  var stopStr = generateDefaultStopText(segmentsLength, translation);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledStopoverContainer, (0, _extends2.default)({
    size: _constant.WIDTH[size],
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties), !!showText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "block",
    textAlign: "center",
    theme: theme,
    type: "small",
    color: _constant.COLOR.TEXT_COLOR,
    customProperties: {
      style: {
        marginBottom: -8
      }
    }
  }, "".concat(_utilities.default.constructDuration(hour, minute, language), " ").concat(day > 0 ? "(+".concat(day, ")") : '')), /*#__PURE__*/_react.default.createElement(StyledStopoverSVG, {
    width: _constant.WIDTH[size],
    height: "20"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    strokeWidth: "2"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeDasharray: "2, 2",
    d: "M5 10 l".concat(_constant.WIDTH[size], " 0")
  })), /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "2"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    id: "start",
    cx: _constant.PATH_POSITION[size].start,
    cy: "10",
    r: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    id: "end",
    cx: _constant.PATH_POSITION[size].end,
    cy: "10",
    r: "1"
  })), /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "3"
  }, segmentsLength === 1 && /*#__PURE__*/_react.default.createElement("rect", {
    x: _constant.PATH_POSITION[size].stop1,
    y: "9.5",
    ry: "0.1",
    width: "1",
    height: "1",
    className: "stopover"
  }), segmentsLength >= 2 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("rect", {
    x: _constant.PATH_POSITION[size].stop2Start,
    y: "9.5",
    ry: "0.1",
    width: "1",
    height: "1",
    className: "stopover"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: _constant.PATH_POSITION[size].stop2End,
    y: "9.5",
    ry: "0.1",
    width: "1",
    height: "1",
    className: "stopover"
  })))), !!showText && /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: "block",
    textAlign: "center",
    theme: theme,
    type: "small",
    color: _constant.COLOR.TEXT_COLOR,
    customProperties: {
      style: {
        marginTop: -8
      }
    }
  }, stopStr)));
};
Stopover.propTypes = _stopover.default.PropTypes;
Stopover.defaultProps = _stopover.default.DefaultProps;
var _default = Stopover;
exports.default = _default;